import { buildHierarchyMap } from '@/utils';

export default {
  setLoading(state, payload) {
    state.loading = payload;
  },

  setGroups(state, payload) {
    state.groups = payload;
  },

  setCurrentGroup(state, payload) {
    state.currentGroup = payload;
  },

  setGroupsMap(state, payload) {
    state.groupsMap = buildHierarchyMap(payload);
  },
};
